import { Component, Input } from "@angular/core";
import { ProcessExecutionStatusStep } from "@modules/common/models/process-execution-status-step";
import { ProcessStepStatusEnum } from "@modules/common/enums/process-step-status.enum";

/**
 * Component to track the progress of an executing process
 * by showing the steps of the process and the status of
 * each step.
 */
@Component({
	selector: 'app-process-execution-status',
	templateUrl: './process-execution-status.component.html',
	styleUrls: ['./process-execution-status.component.scss']
})
export class ProcessExecutionStatusComponent {
	public readonly ProcessStepStatusEnum = ProcessStepStatusEnum;

	/**
	 * The list of steps and statuses to show.
	 */
	@Input()
	public steps!: ProcessExecutionStatusStep[];
}